import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft } from "@tabler/icons-react";
import { AdminPageHeader, Button } from "@/components/ui";

export function CatalogosContablesHeader() {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Catálogos contables"
      description="Centros de costo y cuentas contables · usados por el prorrateo y la generación de pólizas SAP. El código funcional es inmutable; nombre y código SAP se editan."
      actions={
        <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
          Volver
        </Button>
      }
    />
  );
}
